module.exports = __webpack_public_path__ + "img/viola-logo-white.ac738287.svg";